import { render, staticRenderFns } from "./PhpExtendedSupportCreateSubscription.vue?vue&type=template&id=1b5d9f4c&scoped=true"
import script from "./PhpExtendedSupportCreateSubscription.vue?vue&type=script&lang=js"
export * from "./PhpExtendedSupportCreateSubscription.vue?vue&type=script&lang=js"
import style0 from "./PhpExtendedSupportCreateSubscription.vue?vue&type=style&index=0&id=1b5d9f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d9f4c",
  null
  
)

export default component.exports